import React from "react";
import {Route, Routes} from "react-router-dom";
import {Helmet} from "react-helmet";
import {useChatStore} from "../../chatbot/store/chatbotStore";
import SquadflixTvHome from "./screens/SquadflixTvHome";
import SquadflixTvMovieDetails from "./screens/SquadflixTvMovieDetails";
import SquadflixTvSerieDetails from "./screens/SquadflixTvSerieDetails";
import {SquadflixTvEpisodeDetails} from "./screens/SquadflixTvPlayerView";
import SquadflixTvSearch from "./screens/SquadflixTvSearch";
import {SquadflixTvLiveChannelDetails, SquadflixTvLiveHub} from "./screens/SquadflixTvLive";
import {SquadflixLiveStream} from "../squadflixLive/squadflixLiveStream/squadflixLiveStream";
import LiveCustomLinks from "../movies/liveCustomLinks/liveCustomLinks";
import LiveChannelDetails from "../movies/liveChannelDetails/liveChannelDetails";
import LiveEventDetails from "../movies/liveEventDetails/liveEventDetails";
import SquadflixDeviceLinker from "../squadflix-device-linker/squadflix-device-linker";
import TorrentsDashboard from "../torrentsDashboard/torrentsDashboard";
import "./SquadflixTvIndex.scss";

type Props = {
    squadflixTvHook?: any;
    acestreamLinks?: any[];
    onWidthChange?: () => void;
};

const SquadflixTvIndex: React.FC<Props> = ({squadflixTvHook, acestreamLinks = [], onWidthChange}) => {
    const {hasPermission} = useChatStore();

    return (
        <div className="squadflix-tv-container">
            <Helmet>
                <meta charSet="utf-8" />
                <title>SquadFlix TV</title>
            </Helmet>

            <Routes>
                <Route path="/" element={<SquadflixTvHome />} />
                <Route path="/home" element={<SquadflixTvHome />} />
                <Route path="/search-tmdb" element={<SquadflixTvSearch />} />
                <Route path="/live" element={<SquadflixTvLiveHub />} />
                <Route path="/live/channel/:id" element={<SquadflixTvLiveChannelDetails />} />
                <Route path="/live/channel/:channelId/stream/:streamId" element={<SquadflixLiveStream />} />
                <Route path="/live/custom" element={<LiveCustomLinks />} />
                <Route path="/live/custom/play/:id" element={<LiveChannelDetails acestreamLinks={undefined} />} />
                <Route path="/live/:id" element={<LiveChannelDetails acestreamLinks={acestreamLinks} />} />
                <Route path="/live-event/:eventId/:option" element={<LiveEventDetails />} />
                <Route
                    path="/movies/:id/*"
                    element={<SquadflixTvMovieDetails squadflixTvHook={squadflixTvHook} />}
                />
                <Route
                    path="/series/:id"
                    element={<SquadflixTvSerieDetails squadflixTvHook={squadflixTvHook} />}
                />
                <Route
                    path="/series/:serieId/:seasonNumber/:episodeNumber"
                    element={<SquadflixTvEpisodeDetails squadflixTvHook={squadflixTvHook} />}
                />
                <Route path="/link" element={<SquadflixDeviceLinker />} />
                {hasPermission("towersstreamDashboard") && (
                    <Route
                        path="/towersstream/dash"
                        element={<TorrentsDashboard onWidthChange={onWidthChange} />}
                    />
                )}
            </Routes>
        </div>
    );
};

export default SquadflixTvIndex;
